import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { IUser } from '@mirasoles/shared';
import { authApi } from '../api';

interface AuthState {
  user: IUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  login: (email: string, password: string, portalSlug?: string) => Promise<void>;
  logout: () => void;
  /** Reemplaza el usuario en memoria (ej. tras editar el perfil) sin tocar los tokens. */
  setUser: (user: IUser) => void;
  isAuthenticated: () => boolean;
}

export const useAuth = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,

      login: async (email, password, portalSlug) => {
        const res = await authApi.login(email, password, portalSlug);
        localStorage.setItem('accessToken', res.accessToken);
        localStorage.setItem('refreshToken', res.refreshToken);
        set({ user: res.user as IUser, accessToken: res.accessToken, refreshToken: res.refreshToken });
      },

      logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        set({ user: null, accessToken: null, refreshToken: null });
      },

      setUser: (user) => set({ user }),

      isAuthenticated: () => !!get().accessToken && !!get().user,
    }),
    { name: 'auth-store', partialize: (s) => ({ user: s.user, accessToken: s.accessToken, refreshToken: s.refreshToken }) },
  ),
);
